// @ts-nocheck
import { QUICK_SEARCH_TICKET_CHANGED, QUICK_SEARCH_FETCHING_CHANGED } from '../types';

const initialState = {
    ticket: null,
    isFetching: false,
};

const quickSearch = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case QUICK_SEARCH_TICKET_CHANGED: {
            return {
                ...state,
                ticket: payload,
            };
        }
        case QUICK_SEARCH_FETCHING_CHANGED: {
            return {
                ...state,
                isFetching: payload,
            };
        }
        default:
            return state;
    }
};

export default quickSearch;
